export default "__VITE_ASSET__D8kfOYJ2__"